import { css, Interpolation, Theme } from '@emotion/react'
import { buttonBaseClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const wrapper: Interpolation<Theme> = css`
  position: relative;
`

export const buttonsWrapper = (theme: Theme) => css`
  position: absolute;
  z-index: 2;

  display: flex;
  column-gap: ${theme.spacing(1)};

  right: ${theme.spacing(1.75)};
  top: ${theme.spacing(1.75)};
`

export const iconButton: Interpolation<Theme> = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const input = (theme: Theme) => css`
  width: 100%;
  resize: vertical;

  padding-right: ${theme.spacing(12)};
`

export const valueWrapper = (theme: Theme) => css`
  min-height: 80px;
  padding: ${theme.spacing(1.75)};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2)};

  background-color: ${theme.colors.white};
`
